// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-card {

  background: white;
  padding: 22px 18px;

  border-radius: 18px;

  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: 280px;

  min-width: 300px;
  max-width: 300px;
  width: 100%;

  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);

  transition: 0.3s ease;

  border: 1px solid #f3f3f3;

}

.network-card:hover {

  transform: translateY(-5px);

  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.08);

}

.network-avatar {

  width: 90px;
  height: 90px;

  border-radius: 50%;

  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #f5f5f5;

  margin-bottom: 15px;

  border: 3px solid rgba(26, 115, 232, 0.1);

}

.network-avatar img {

  width: 100%;
  height: 100%;

  object-fit: cover;

}

.network-avatar svg {

  font-size: 35px;
  color: #888;

}

.network-card h4 {

  margin: 0;
  margin-bottom: 10px;

  font-size: 18px;
  font-weight: 600;

  color: #222;

}

.role-badge {

  padding: 6px 14px;

  border-radius: 30px;

  font-size: 13px;
  font-weight: 600;

  margin-bottom: 20px;

  text-transform: capitalize;

}

.role-badge.athlete {

  background: #eef4ff;
  color: #1a73e8;

}

.role-badge.club {

  background: #eafaf0;
  color: #16a34a;

}

.role-badge.agent {

  background: #fff3e6;
  color: #f59e0b;

}

.role-badge.coach {

  background: #f4eaff;
  color: #9333ea;

}

.network-actions {

  margin-top: auto;

  display: flex;

  width: 100%;

  gap: 10px;

}

.network-actions button {

  flex: 1 1;

  height: 42px;

  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;

  transition: .3s;

}

.btn-primary {

  background: var(--primary-100);
  color: white;
  border: none;

}

.btn-primary:hover {

  opacity: .9;
  /* transform: scale(1.03); */

}

.btn-outline {

  border: 1px solid var(--primary-100);
  background: white;
  color: var(--primary-100);

}

.btn-outline:hover {

  background: #f7faff;

}

@media(max-width:768px) {

  .network-card {

    min-height: auto;
    padding: 18px;

  }

  .network-actions {

    flex-direction: column;

  }

}


.toast {

  position: fixed;

  bottom: 30px;
  left: 50%;

  transform: translateX(-50%);

  background: rgba(20, 20, 20, .95);

  color: white;

  padding: 14px 22px;

  border-radius: 50px;

  font-size: 14px;
  font-weight: 600;

  backdrop-filter: blur(10px);

  box-shadow:
    0 10px 25px rgba(0, 0, 0, .25);

  animation:
    toastIn .4s ease;

  z-index: 99999;

}

@keyframes toastIn {

  from {

    opacity: 0;

    transform:
      translate(-50%, 30px);

  }

  to {

    opacity: 1;

    transform:
      translate(-50%, 0);

  }

}

.btn-following {

  background: #f3f4f6;

  color: #111827;

  border: none;

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 8px;

}

.btn-following:hover {

  background: #e5e7eb;

}

/* Discovery profile cards: compact high-tech modules. */
.network-page .network-card {
  box-sizing: border-box;
  position: relative;
  min-width: 252px;
  max-width: 252px;
  min-height: 236px;
  padding: 16px;
  overflow: hidden;
  align-items: flex-start;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 17px;
  background: #fbfcfd;
  box-shadow: 0 10px 24px rgba(30, 63, 88, .07), inset 0 1px #ffffff;
  text-align: left;
}

.network-page .network-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 22px;
  left: 22px;
  height: 2px;
  background: rgba(78, 119, 153, .3);
}

.network-page .network-card:hover {
  border-color: rgba(233, 90, 19, .26);
  box-shadow: 0 15px 30px rgba(30, 63, 88, .11), inset 0 1px #ffffff;
  transform: translateY(-3px);
}

.network-page .network-avatar {
  width: 58px;
  height: 58px;
  margin: 1px 0 12px;
  border: 2px solid #ffffff;
  border-radius: 16px;
  color: #ffffff;
  background: #4e7799;
  box-shadow: 0 6px 14px rgba(78, 119, 153, .18);
}

.network-page .network-avatar img { border-radius: 12px; }
.network-page .network-avatar svg { color: #ffffff; font-size: 1.25rem; }

.network-page .network-card h4 {
  overflow: hidden;
  width: 100%;
  margin: 0 0 6px;
  color: #29475e;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .9rem;
  font-weight: 850;
  letter-spacing: -.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.network-page .role-badge {
  margin: 0 0 15px;
  padding: 5px 8px;
  border: 1px solid rgba(233, 90, 19, .18);
  border-radius: 999px;
  color: #a83e0d;
  background: #fff3ec;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .61rem;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.network-page .network-actions { gap: 7px; }
.network-page .network-actions button {
  height: 38px;
  padding: 7px;
  border-radius: 10px;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .68rem;
  font-weight: 800;
  transition: .18s ease;
}

.network-page .network-actions .btn-outline {
  border: 1px solid rgba(78, 119, 153, .24);
  color: #4e7799;
  background: #ffffff;
}

.network-page .network-actions .btn-outline:hover { border-color: rgba(233, 90, 19, .3); color: #d84f0d; background: #fff3ec; }
.network-page .network-actions .btn-primary { border: 1px solid #e95a13; background: #e95a13; box-shadow: 0 6px 13px rgba(233, 90, 19, .16); }
.network-page .network-actions .btn-primary:hover { background: #d84f0d; }
.network-page .network-actions .btn-following { border: 1px solid rgba(78, 119, 153, .18); color: #4e7799; background: #edf3f6; }

@media (max-width: 768px) {
  .network-page .network-card { min-width: min(252px, calc(100vw - 44px)); max-width: min(252px, calc(100vw - 44px)); }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/NetworkCard.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,kBAAkB;;EAElB,mBAAmB;;EAEnB,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,iBAAiB;;EAEjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;;EAEX,0CAA0C;;EAE1C,qBAAqB;;EAErB,yBAAyB;;AAE3B;;AAEA;;EAEE,2BAA2B;;EAE3B,2CAA2C;;AAE7C;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;;EAElB,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,yCAAyC;;AAE3C;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,iBAAiB;;AAEnB;;AAEA;;EAEE,eAAe;EACf,WAAW;;AAEb;;AAEA;;EAEE,SAAS;EACT,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,WAAW;;AAEb;;AAEA;;EAEE,iBAAiB;;EAEjB,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;;EAEnB,0BAA0B;;AAE5B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;;EAEE,gBAAgB;;EAEhB,aAAa;;EAEb,WAAW;;EAEX,SAAS;;AAEX;;AAEA;;EAEE,SAAO;;EAEP,YAAY;;EAEZ,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,eAAe;;AAEjB;;AAEA;;EAEE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;;AAEd;;AAEA;;EAEE,WAAW;EACX,4BAA4B;;AAE9B;;AAEA;;EAEE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;;AAE3B;;AAEA;;EAEE,mBAAmB;;AAErB;;AAEA;;EAEE;;IAEE,gBAAgB;IAChB,aAAa;;EAEf;;EAEA;;IAEE,sBAAsB;;EAExB;;AAEF;;;AAGA;;EAEE,eAAe;;EAEf,YAAY;EACZ,SAAS;;EAET,2BAA2B;;EAE3B,iCAAiC;;EAEjC,YAAY;;EAEZ,kBAAkB;;EAElB,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,2BAA2B;;EAE3B;kCACgC;;EAEhC;oBACkB;;EAElB,cAAc;;AAEhB;;AAEA;;EAEE;;IAEE,UAAU;;IAEV;2BACuB;;EAEzB;;EAEA;;IAEE,UAAU;;IAEV;wBACoB;;EAEtB;;AAEF;;AAEA;;EAEE,mBAAmB;;EAEnB,cAAc;;EAEd,YAAY;;EAEZ,aAAa;;EAEb,mBAAmB;;EAEnB,uBAAuB;;EAEvB,QAAQ;;AAEV;;AAEA;;EAEE,mBAAmB;;AAErB;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,cAAc,EAAE,kBAAkB,EAAE;;AAExE;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,oEAAoE;EACpE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iCAAiC,QAAQ,EAAE;AAC3C;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,mBAAmB;AACrB;;AAEA,oDAAoD,mCAAmC,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9H,8CAA8C,yBAAyB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;AAC7I,oDAAoD,mBAAmB,EAAE;AACzE,gDAAgD,yCAAyC,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAEhI;EACE,8BAA8B,yCAAyC,EAAE,yCAAyC,EAAE;AACtH","sourcesContent":[".network-card {\n\n  background: white;\n  padding: 22px 18px;\n\n  border-radius: 18px;\n\n  text-align: center;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  min-height: 280px;\n\n  min-width: 300px;\n  max-width: 300px;\n  width: 100%;\n\n  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);\n\n  transition: 0.3s ease;\n\n  border: 1px solid #f3f3f3;\n\n}\n\n.network-card:hover {\n\n  transform: translateY(-5px);\n\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.08);\n\n}\n\n.network-avatar {\n\n  width: 90px;\n  height: 90px;\n\n  border-radius: 50%;\n\n  overflow: hidden;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #f5f5f5;\n\n  margin-bottom: 15px;\n\n  border: 3px solid rgba(26, 115, 232, 0.1);\n\n}\n\n.network-avatar img {\n\n  width: 100%;\n  height: 100%;\n\n  object-fit: cover;\n\n}\n\n.network-avatar svg {\n\n  font-size: 35px;\n  color: #888;\n\n}\n\n.network-card h4 {\n\n  margin: 0;\n  margin-bottom: 10px;\n\n  font-size: 18px;\n  font-weight: 600;\n\n  color: #222;\n\n}\n\n.role-badge {\n\n  padding: 6px 14px;\n\n  border-radius: 30px;\n\n  font-size: 13px;\n  font-weight: 600;\n\n  margin-bottom: 20px;\n\n  text-transform: capitalize;\n\n}\n\n.role-badge.athlete {\n\n  background: #eef4ff;\n  color: #1a73e8;\n\n}\n\n.role-badge.club {\n\n  background: #eafaf0;\n  color: #16a34a;\n\n}\n\n.role-badge.agent {\n\n  background: #fff3e6;\n  color: #f59e0b;\n\n}\n\n.role-badge.coach {\n\n  background: #f4eaff;\n  color: #9333ea;\n\n}\n\n.network-actions {\n\n  margin-top: auto;\n\n  display: flex;\n\n  width: 100%;\n\n  gap: 10px;\n\n}\n\n.network-actions button {\n\n  flex: 1;\n\n  height: 42px;\n\n  border-radius: 10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n\n  font-size: 14px;\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: .3s;\n\n}\n\n.btn-primary {\n\n  background: var(--primary-100);\n  color: white;\n  border: none;\n\n}\n\n.btn-primary:hover {\n\n  opacity: .9;\n  /* transform: scale(1.03); */\n\n}\n\n.btn-outline {\n\n  border: 1px solid var(--primary-100);\n  background: white;\n  color: var(--primary-100);\n\n}\n\n.btn-outline:hover {\n\n  background: #f7faff;\n\n}\n\n@media(max-width:768px) {\n\n  .network-card {\n\n    min-height: auto;\n    padding: 18px;\n\n  }\n\n  .network-actions {\n\n    flex-direction: column;\n\n  }\n\n}\n\n\n.toast {\n\n  position: fixed;\n\n  bottom: 30px;\n  left: 50%;\n\n  transform: translateX(-50%);\n\n  background: rgba(20, 20, 20, .95);\n\n  color: white;\n\n  padding: 14px 22px;\n\n  border-radius: 50px;\n\n  font-size: 14px;\n  font-weight: 600;\n\n  backdrop-filter: blur(10px);\n\n  box-shadow:\n    0 10px 25px rgba(0, 0, 0, .25);\n\n  animation:\n    toastIn .4s ease;\n\n  z-index: 99999;\n\n}\n\n@keyframes toastIn {\n\n  from {\n\n    opacity: 0;\n\n    transform:\n      translate(-50%, 30px);\n\n  }\n\n  to {\n\n    opacity: 1;\n\n    transform:\n      translate(-50%, 0);\n\n  }\n\n}\n\n.btn-following {\n\n  background: #f3f4f6;\n\n  color: #111827;\n\n  border: none;\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: center;\n\n  gap: 8px;\n\n}\n\n.btn-following:hover {\n\n  background: #e5e7eb;\n\n}\n\n/* Discovery profile cards: compact high-tech modules. */\n.network-page .network-card {\n  box-sizing: border-box;\n  position: relative;\n  min-width: 252px;\n  max-width: 252px;\n  min-height: 236px;\n  padding: 16px;\n  overflow: hidden;\n  align-items: flex-start;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 17px;\n  background: #fbfcfd;\n  box-shadow: 0 10px 24px rgba(30, 63, 88, .07), inset 0 1px #ffffff;\n  text-align: left;\n}\n\n.network-page .network-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 22px;\n  left: 22px;\n  height: 2px;\n  background: rgba(78, 119, 153, .3);\n}\n\n.network-page .network-card:hover {\n  border-color: rgba(233, 90, 19, .26);\n  box-shadow: 0 15px 30px rgba(30, 63, 88, .11), inset 0 1px #ffffff;\n  transform: translateY(-3px);\n}\n\n.network-page .network-avatar {\n  width: 58px;\n  height: 58px;\n  margin: 1px 0 12px;\n  border: 2px solid #ffffff;\n  border-radius: 16px;\n  color: #ffffff;\n  background: #4e7799;\n  box-shadow: 0 6px 14px rgba(78, 119, 153, .18);\n}\n\n.network-page .network-avatar img { border-radius: 12px; }\n.network-page .network-avatar svg { color: #ffffff; font-size: 1.25rem; }\n\n.network-page .network-card h4 {\n  overflow: hidden;\n  width: 100%;\n  margin: 0 0 6px;\n  color: #29475e;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .9rem;\n  font-weight: 850;\n  letter-spacing: -.01em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.network-page .role-badge {\n  margin: 0 0 15px;\n  padding: 5px 8px;\n  border: 1px solid rgba(233, 90, 19, .18);\n  border-radius: 999px;\n  color: #a83e0d;\n  background: #fff3ec;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .61rem;\n  font-weight: 800;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n.network-page .network-actions { gap: 7px; }\n.network-page .network-actions button {\n  height: 38px;\n  padding: 7px;\n  border-radius: 10px;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .68rem;\n  font-weight: 800;\n  transition: .18s ease;\n}\n\n.network-page .network-actions .btn-outline {\n  border: 1px solid rgba(78, 119, 153, .24);\n  color: #4e7799;\n  background: #ffffff;\n}\n\n.network-page .network-actions .btn-outline:hover { border-color: rgba(233, 90, 19, .3); color: #d84f0d; background: #fff3ec; }\n.network-page .network-actions .btn-primary { border: 1px solid #e95a13; background: #e95a13; box-shadow: 0 6px 13px rgba(233, 90, 19, .16); }\n.network-page .network-actions .btn-primary:hover { background: #d84f0d; }\n.network-page .network-actions .btn-following { border: 1px solid rgba(78, 119, 153, .18); color: #4e7799; background: #edf3f6; }\n\n@media (max-width: 768px) {\n  .network-page .network-card { min-width: min(252px, calc(100vw - 44px)); max-width: min(252px, calc(100vw - 44px)); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
